import { _ } from '@lang'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const Translate = ({ str, vars }) => {
  // eslint-disable-next-line no-unused-vars
  const currLang = useSelector((state) => state.app.lang)
  return <>{_(str, vars)}</>
}

Translate.defaultProps = {}
Translate.propTypes = {
  str: PropTypes.string.isRequired,
  vars: PropTypes.objectOf(PropTypes.any),
}

export default Translate
